import { GoalFormInitialValues } from "./types"

export const COMMUNITY_EVENT_DEFAULT_MIN_CONTRIBUTION = 50

export const emptyGoal = (): GoalFormInitialValues => ({
  minContribution: COMMUNITY_EVENT_DEFAULT_MIN_CONTRIBUTION,
  sources: [{}],
  milestones: [],
})
